module.exports = __webpack_public_path__ + "img/case11.1e7d552e.png";